document.addEventListener('DOMContentLoaded', function() {
  const backInStockButtons = document.querySelectorAll('[data-back-in-stock-notification]');

  backInStockButtons.forEach(button => {
    button.setAttribute('type', 'button'); // Change type to button to prevent form submission  
    
    button.addEventListener('click', function() {
      const productId = this.closest('form').querySelector('input[name="id"]').value;
      // Here you would typically open a modal or redirect to a form where the user can enter their email to be notified.
      document.querySelector('klaviyo-modal').open();
      // document.querySelector('#klaviyo-modal-subscribe').setAttribute('aria-hidden', 'false');
      // document.documentElement.classList.add('klaviyo-modal-open');

      // document.documentElement.classList.remove("klaviyo-modal-open");
      // document.querySelector('#klaviyo-modal-subscribe').setAttribute('aria-hidden', 'true');



    });
  });
}); 

class KlaviyoWaitlistModal extends HTMLElement {
  constructor() {
    super();
    this.modal = document.getElementById("klaviyo-modal-subscribe");

    this.dialog = this.modal.querySelector(".klaviyo-modal__dialog");
    this.content = this.modal.querySelector(".klaviyo-modal__content");
    this.form = this.modal.querySelector("[data-klaviyo-form]");
    this.emailInput = this.modal.querySelector('input[type="email"]');
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    this.successMessage = this.modal.querySelector(".klaviyo-modal__success");

    document.getElementById("klaviyo-modal-disabled-buttons")?.remove();

    this.open = this.open.bind(this);
    this.init();
  }

  init() {
    this.bindClose();
    this.bindKeyboard();
    this.bindSubmit();
  }

  open() {
    this.modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("klaviyo-modal-open");

    setTimeout(() => {
      this.emailInput?.focus();
    }, 0);
  }

  close() {
    this.modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("klaviyo-modal-open");
  }

  bindClose() {
    this.modal.addEventListener("click", (e) => {
      if (
        e.target.matches("[data-modal-close]") ||
        !this.dialog.contains(e.target)
      ) {
        this.close();
      }
    });
  }

  bindKeyboard() {
    document.addEventListener("keydown", (e) => {
      if (this.modal.getAttribute("aria-hidden") !== "false") return;
      if (e.key === "Escape") {
        this.close();
      }
    });
  }

  submit(email, variantId) {
    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    }

    var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-06-15"
        },
        body: JSON.stringify(payload),
    };

    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=TqQd3B", requestOptions)
        .then(result => console.log(result))
        .catch(error => console.log('error', error));

  }


  bindSubmit() {
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();

      const email = this.emailInput.value.trim();
      const variantId = document.querySelector('[data-back-in-stock-notification]')?.getAttribute('data-back-in-stock-notification');


      if (!email) return;

      this.submit(email, variantId);

      this.showSuccessState();
    });
  }

  showSuccessState() {
    this.content.classList.add("blocked");

    if (this.submitButton) {
      this.submitButton.textContent = "Subscribed";
      this.submitButton.disabled = true;
    }

    if (this.successMessage) {
      this.successMessage.classList.remove("hidden");
    }
  }
}
customElements.define("klaviyo-modal", KlaviyoWaitlistModal);